import RangeSlider from 'react-range-slider-input'
import 'react-range-slider-input/dist/style.css'
import './Range.Style.css'
import { useSelector } from 'react-redux'
import props from '../../../redux/props'
import { formatNumber } from '../../../utility'

export type RangeProps = {
  value: number
  onChange: (value: number) => void
  min?: number
  max?: number
  step?: number
  leftLabel?: string
  rightLabel?: string
  hidePercentage?: boolean
  labelClassName?: string
  small?: boolean
  percentageSuffix?: string
  customCurrentValueLabel?: string | React.ReactNode
}

const Range: React.FC<RangeProps> = ({
  value,
  onChange,
  min = 0,
  max = 100,
  step = 5,
  leftLabel,
  rightLabel,
  hidePercentage = false,
  labelClassName = '',
  small = false,
  percentageSuffix,
  customCurrentValueLabel,
}) => {
  const t = useSelector((s) => s[props.TRANSLATION])

  const update = (value: number[]) => {
    onChange(value[1])
  }

  return (
    <div className="w-full">
      <RangeSlider
        className={`single-thumb ${small && 'small'}`}
        thumbsDisabled={[true, false]}
        rangeSlideDisabled={true}
        value={[0, value || 0]}
        onInput={update}
        max={max}
        min={min}
        step={step}
      />
      <div>
        <div className="flex flex-row mt-1">
          <div className={`truncate flex-1 text-sm text-gray ${labelClassName}`}>{leftLabel || ''}</div>
          {!hidePercentage && (
            <div className={`truncate flex-1 text-center text-sm text-gray ${labelClassName}`}>
              {!customCurrentValueLabel && value > 0 ? `${formatNumber(value)}${percentageSuffix || t.generic.percent}` : ''}
              {customCurrentValueLabel && customCurrentValueLabel}
            </div>
          )}
          <div className={`truncate flex-1 text-right text-sm text-gray ${labelClassName}`}>{rightLabel || ''}</div>
        </div>
      </div>
    </div>
  )
}

export default Range
